import { EventEmitter, Injectable, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ErrorDialogComponent } from '../ui-component-library/error-dialog/error-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingService {
  public isDialogOpen: Boolean = false;
  public refreshing: Boolean = false;
  error: any;

  @Output() syncEvent = new EventEmitter();

  constructor(
    public dialog: MatDialog,
    public router: Router
  ) {}

  handleError(error: any): any {
    this.error = error;
    let data = {
      reason: error.message,
      status: error.status,
      name: error.name,
      detail: error.message,
    };
    switch (error.status) {
      case 0:
        data.reason = 'Network Services Failure';
        data.detail = 'The application was unable to connect to a required server.';
        this.openDialog(data);
        break;
      case 404:
        data.reason = 'API Access Error';
        data.detail = 'The server responded but the application was unable to connect to required API endpoint.';
        this.refreshing = true;
        this.openDialog(data);
        break;
      case 401:
        data.reason = 'Login Required';
        data.detail = 'The application requires a new login.';
        this.refreshing = true;
        // this.config.stopHash();
        this.openDialog(data);
        break;
      case 209:
      case 409:
        data.reason = 'Conflict';
        if (error.body) {
          // let message :string = error.body.Message;
          // let source :string = error.body.Source;
          // let s = message.search('UniqueItem');
          // if(s!=-1){
          //     let keys :string | null = error.body.Message.split('key value is (')[1]
          //     keys  =keys?keys.split(').')[0]:null;
          //     data.detail="Unable to create duplicated record with Item value(s) '"+keys+"'.";
          //     data.name = source;
          //     this.openDialog(data);
          // }
          // else if(message.search('UniqueBin')!=-1){
          //     let keys :string | null = error.body.Message.split('key value is (')[1]
          //     keys  =keys?keys.split(').')[0]:null;
          //     data.detail="Unable to create duplicated record with Bin value '"+keys+"'.";
          //     data.name = source;
          //     this.openDialog(data);
          // }
          // else  if(message.search('UniqueScheduleStore')!=-1){
          //     data.reason='Store Conflict'
          //     let keys :string | null = error.body.Message.split('key value is (')[1]
          //     keys  =keys?keys.split(').')[0]:null;
          //     data.detail="Unable to create a new schedule for an already scheduled store. Check store selection or existing record.";
          //     data.name = source;
          //     this.openDialog(data);
          // }
          // else if(message.search('UniqueLoads')!=-1){
          //     data.reason='Load Assignment Conflict'
          //       data.detail="The specified load number is in use.";
          //     data.name = source;
          //     this.openDialog(data);
          // }
          // else if(message.search('UniqueLoadDrivers')!=-1){
          //     data.reason='Load Assignment Conflict'
          //       data.detail="The specified driver is already assigned to a load.";
          //     data.name = source;
          //     this.openDialog(data);
          // }
        }
        break;
      case 500:
        data.reason = 'Unexpected Application Failure';
        this.refreshing = true;
        // this.config.stopHash();
        this.openDialog(data);
        break;
      default:
        // this.config.stopHash();
        this.refreshing = true;
        this.openDialog(data);
        break;
    }
  }

  openDialog(data: any): any {
    //TODO: Add conditions to prevent dialog open on every service failure
    // if (this.isDialogOpen) {
    //     return false;
    // }
    // this.isDialogOpen = true;
    // const dialogRef = this.dialog.open(ErrorDialogComponent, {
    //     width: '450px',height: 'auto',
    //     data: data
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //     this.isDialogOpen = false;
    //     this.dialog.closeAll();
    //     this.refreshing?window.location.reload():null;
    // });
  }
}
